/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel, RedirectRequest } from "@azure/msal-browser";
import appConfig from "../utils/appConfig";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

//  REACT_APP_ADB2C_CLIENT_ID="abcdef12-e3f9-43h0-0ad9-7b0g5h8rsm28"
//  REACT_APP_ADB2C_AUTHORITY="https://mytenant.b2clogin.com/mytenant.onmicrosoft.com/B2C_1_susi"
//  REACT_APP_ADB2C_KNOWN_AUTHORITIES="mytenant.b2clogin.com,"

//  REACT_APP_ADB2C_REDIRECT_URI="http://localhost:3006"
//  REACT_APP_ADB2C_POST_LOGOUT_REDIRECT_URI="http://localhost:3006"

//  REACT_APP_ADB2C_SIGNUP_SIGNIN_POLICY="B2C_1_susi"

const tenant = appConfig.b2c.tenant;
const signInPolicy = appConfig.b2c.signInPolicy;
const applicationID = appConfig.b2c.applicationID;
// const reactRedirectUri = appConfig.b2c.reactRedirectUri;
const logoutRedirectUri = appConfig.b2c.logoutRedirectUri;
const tenantSubdomain = tenant?.split(".")[0];
const instance = `https://${tenantSubdomain}.b2clogin.com/`;
const signInAuthority = `${instance}${tenant}/${signInPolicy}`;

export const msalConfig: Configuration = {
  auth: {
    clientId: applicationID,
    authority: signInAuthority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: logoutRedirectUri,
    knownAuthorities: [`${tenantSubdomain}.b2clogin.com`],
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
  scopes: [
    `https://${tenantSubdomain}.onmicrosoft.com/report-portal-api/access.all`,
  ],
  // redirectStartPage: "http://localhost:3000/reports",
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me",
};
